var _path, _ellipse, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShopping1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M804 201L804 229",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 804.5,
    cy: 196.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M801.105 205C800.637 205 800.236 204.834 799.903 204.501C799.57 204.168 799.403 203.768 799.403 203.3C799.403 202.833 799.57 202.432 799.903 202.099C800.236 201.766 800.637 201.6 801.105 201.6C801.573 201.6 801.973 201.766 802.306 202.099C802.64 202.432 802.806 202.833 802.806 203.3C802.806 203.768 802.64 204.168 802.306 204.501C801.973 204.834 801.573 205 801.105 205ZM809.613 205C809.145 205 808.744 204.834 808.411 204.501C808.078 204.168 807.911 203.768 807.911 203.3C807.911 202.833 808.078 202.432 808.411 202.099C808.744 201.766 809.145 201.6 809.613 201.6C810.081 201.6 810.481 201.766 810.814 202.099C811.148 202.432 811.314 202.833 811.314 203.3C811.314 203.768 811.148 204.168 810.814 204.501C810.481 204.834 810.081 205 809.613 205ZM800.382 191.4L802.423 195.65H808.379L810.719 191.4H800.382ZM799.573 189.7H812.122C812.449 189.7 812.697 189.845 812.867 190.136C813.037 190.426 813.044 190.72 812.888 191.018L809.868 196.457C809.712 196.741 809.503 196.96 809.24 197.116C808.978 197.272 808.691 197.35 808.379 197.35H802.041L801.105 199.05H811.314V200.75H801.105C800.467 200.75 799.985 200.47 799.658 199.911C799.332 199.351 799.318 198.795 799.616 198.242L800.764 196.16L797.702 189.7H796V188H798.765L799.573 189.7Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopping1);
export default __webpack_public_path__ + "static/media/shopping_1.50ef31d613bbfdd3efa69a2474f04aa7.svg";
export { ForwardRef as ReactComponent };